import { Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { SketchPicker } from 'react-color';
import styles from './AOIEditLineModal.module.css';
import { aoiService } from '../../Services/aoiService';

const AOIEditLineModal = (props) => {
    const [file, setFile] = useState(null);
    const [aoiLine, setAoiLine] = useState({
        aoiId: props.aoi.aoiId,
        name: '',
        strokeWeight: "3",
        style: 'solid',
        color: '#ff0000',
        isPipeline: props.aoi.properties?.pipelineId == props.line?.aoiGeometryId,
        ...props.line ?? {},
        ...props.properties ?? {}
    });


    const handleFileChange = (event) => {
        if (event.target.files[0]) {
            setFile(event.target.files[0]);
        } else {
            setFile(null);
        }
    };

    const saveAoiLine = () => {
        if(props.line == null && file == null) {
            toast.error("Please select a file to upload");
            return;
        }
        if(isNaN(parseInt(aoiLine.strokeWeight))) {
            toast.error("Please enter a valid stroke weight");
            return;
        }
        const aoiGeometry = {
            aoiId: props.aoi.aoiId,
            name: aoiLine.name,
            geometryType: "line",
            properties: JSON.stringify({
                style: aoiLine.style,
                color: aoiLine.color,
                strokeWeight: parseInt(aoiLine.strokeWeight)
            }),
            isPipeline: aoiLine.isPipeline ?? false
        };
        if(props.line == null) {
            aoiService.addAoiGeometry(aoiGeometry, file).then((e) => {
                toast.success("Added AOI Geometry successfully");
                props.setShow(false);
                props.onSave();
            }).catch((e) => {
                console.log(e);
                toast.error("Unable to add AOI Geometry");
            });
        } else {
            aoiService.updateAoiGeometry(props.line.aoiGeometryId, aoiGeometry).then((e) => {
                toast.success("Updated AOI Geometry successfully");
                props.setShow(false);
                props.onSave();
            }).catch((e) => {
                console.log(e);
                toast.error("Unable to update AOI Geometry");
            });
        }
    };

    return (
        <Modal
            show={() => props.setShow(true)}
            onHide={() => props.setShow(false)}
            backdrop="static"
            keyboard={false}
            dialogClassName=""
            className=""
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <h5>{props.line == null ? <span>Add AOI Line</span> : <span>Update AOI Line</span>}</h5>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body  className={styles.aoiLineEdit}>
                <div>
                    {
                        props.line == null &&
                        <div className='form-row'>
                            <label  className="form-label" htmlFor="aoiFileUpload">Choose a file (GeoJSON) : &nbsp;</label>
                            <input type="file" className="upload-input" onChange={handleFileChange} accept=".geojson,.kml,.kmz" />
                        </div>
                    }
                    <div className='form-row'>Name: <input type="text" className="form-control" value={aoiLine.name} onChange={(e) => setAoiLine({ ...aoiLine, name: e.target.value })} /></div>
                    <div className='form-row'>Stroke Weight: <input type="number" className="form-control" value={aoiLine.strokeWeight} onChange={(e) => setAoiLine({ ...aoiLine, strokeWeight: e.target.value })} /></div>
                    <div className='form-row'>Style: 
                        <select id="pipeline" name="pipeline" onChange={(e) => setAoiLine({ ...aoiLine, style: e.target.value })} className="form-select" value={aoiLine.style}>
                            <option value="solid">solid</option>
                            <option value="dotted-1">dotted - 1</option>
                            <option value="dotted-2">dotted - 2</option>
                        </select>
                    </div>
                    <div className="form-row">
                        {
                            props.aoi.properties?.pipelineId != null && props.aoi.properties?.pipelineId == props.line?.aoiGeometryId 
                            ? <div style={{color: 'red'}}>This is Main Pipeline.</div>
                            : <>Mark it as Main Pipeline <input type="checkbox" checked={aoiLine.isPipeline ?? false} onChange={(e) => setAoiLine({ ...aoiLine, isPipeline: e.target.checked })} /></>
                        }
                    </div>
                    <div className="form-row">
                        Color:
                        <SketchPicker color={aoiLine.color} onChangeComplete={(color) => setAoiLine({ ...aoiLine, color: color.hex })} />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-text" onClick={() => props.setShow(false)}>CANCEL</button>
                <button type="button" className='btn btn-primary submit-btn' onClick={() => saveAoiLine()}>SAVE</button>
            </Modal.Footer>
        </Modal>
    );
}

export default AOIEditLineModal;